export default class CommonService {
  isEmptyOrWhitespaceString(str) {
    return !str || str.match(/^\s*$/) !== null;
  }
}
